import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/reportParameters', request)
}

export {get}
